// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2yg5P","requiredAsterisk":"Info_requiredAsterisk__1dNI_"};